module.exports = __webpack_public_path__ + "img/view_booking_icon.e2e2eef3.svg";